module.exports = __webpack_public_path__ + "v3/flags.5bc53ca7.png";